/** @jsxImportSource @emotion/react */
import { useState, memo } from "react";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// Visibility
// import eyeicon from "@mui/icons-material/Visibility";

import { useGetBrandIconCardStyles } from "./index.styles";
import Button from "../Button";
import { FavoriteOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

const BrandIconCard = ({
  rounded,
  src,
  src1,
  size,
  maxSize,
  color,
  isFavourite = false,
  isActive = false,
  onFavouriteToggle = (res) => res,
  onSelect = () => void 0,
  showDrawer,
  drawer,
  onActionClick = () => void 0,
  showCardAction = false,
  children,
  address = "",
  brand,
}) => {
  const [isFav, setIsFav] = useState(isFavourite);

  const classes = useGetBrandIconCardStyles({
    rounded,
    size,
    color,
    maxSize,
    isSelected: isActive,
  });

  const onClickHandler = () => {
    onSelect(!isActive);
    if (drawer === true) showDrawer(false);
  };

  const onFavClick = async (e) => {
    e.stopPropagation();
    // const favAddRes = await onFavouriteToggle(e, !isFav);
    setIsFav(!isFav);
  };

  return (
    <div css={classes.selectionWrapper} onClick={onClickHandler}>
      <div css={classes.cardWrapper}>
        <div css={classes.imageView}>
          {/* {src1?.logo_url && <img src={src1?.logo_url} alt={src} key={src} style={{backgroundRepeat : 'no-repeat', width : '55%', height : 'auto'}}/>} */}
          {children}
        </div>
        <IconButton css={classes.favIcon} onClick={onFavClick}>
          {isFav ? (
            <FavoriteOutlined sx={{ color: "red", fontSize: "18px" }} />
          ) : (
            <FavoriteBorderOutlinedIcon
              sx={{ color: "red", fontSize: "18px" }}
            />
          )}
        </IconButton>
      </div>
      {showCardAction && !rounded && (
        <div css={classes.actionWrapper}>
          <Button
            variant="text"
            onClick={(e) => {
              e.stopPropagation();
              onActionClick(e);
            }}
          >
            <Tooltip title={address}>
              <div css={classes.btnWrapper}>
                <LocationOnOutlinedIcon sx={{ fontSize: "1rem" }} />
                <span>View Address</span>
              </div>
            </Tooltip>
          </Button>
        </div>
      )}

      {!showCardAction && brand === "brandcard" && (
        <div css={classes.actionWrapper1}>
          <Button
            variant="text"
            onClick={(e) => {
              e.stopPropagation();
              onActionClick(e);
            }}
          >
            <Tooltip title={address}>
              <div css={classes.btnWrapper}>
                <LocationOnOutlinedIcon sx={{ fontSize: "1rem" }} />
                {/* <span>View</span> */}
              </div>
            </Tooltip>
          </Button>
        </div>
      )}
    </div>
  );
};

export default memo(BrandIconCard);
